import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signIn, isValidEmail } from '../../services/supabase';
import FormInput from '../../components/forms/FormInput';
import '../../styles/components/layout.css';

const LoginPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!isValidEmail(formData.email)) {
            setError('E-mail inválido');
            setLoading(false);
            return;
        }

        if (!formData.password) {
            setError('Senha é obrigatória');
            setLoading(false);
            return;
        }

        try {
            const { user, error: signInError, status } = await signIn(formData);

            if (signInError || status !== 'SUCCESS') {
                throw signInError;
            }

            navigate('/dashboard');
        } catch (err) {
            setError(err.message || 'Erro ao fazer login. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
            <img src="/assets/images/logo.png" alt="Alexander Logo" className="w-48 mb-8" />
            
            <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">
                        Bem-vindo de volta!
                    </h2>
                    <p className="text-gray-600">
                        Não tem uma conta?{' '}
                        <Link to="/cadastro" className="text-accent hover:text-accent-dark font-medium transition-colors">
                            Cadastre-se
                        </Link>
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {error && (
                        <div className="bg-red-50 text-error text-sm p-3 rounded-md">
                            {error}
                        </div>
                    )}

                    <FormInput
                        id="email"
                        name="email"
                        type="email"
                        required
                        placeholder="Seu e-mail"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={loading}
                        label="E-mail"
                    />

                    <FormInput
                        id="password"
                        name="password"
                        type="password"
                        required
                        placeholder="Sua senha"
                        value={formData.password}
                        onChange={handleChange}
                        disabled={loading}
                        label="Senha"
                    />

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 px-4 bg-accent text-white font-medium rounded-md hover:bg-accent-dark focus:outline-none focus:ring-2 focus:ring-accent-dark focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        {loading ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
